import { ReactNode } from 'react';
import { Box } from '@mui/material';

export const DialogInner = ({ children }: { children: ReactNode }) => (
  <Box sx={{ '& .MuiCardContent-root': { paddingTop: 0, paddingBottom: 0 } }}>{children}</Box>
);

export default DialogInner;
